"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuGroup = function MenuGroup(props) {
  var children = props.children,
      title = props.title,
      restProps = _objectWithoutPropertiesLoose(props, ["children", "title"]);

  return [title && (0, _core.jsx)(_styled.MenuGroupTitle, _extends({}, restProps, {
    key: "MenuGroup"
  }), title), children];
};

MenuGroup.displayName = 'MenuGroup';
MenuGroup.propTypes = process.env.NODE_ENV !== "production" ? _propTypes.menuGroupPropTypes : {};
var _default = MenuGroup;
exports.default = _default;